import store from '@/store/index.js'
import firebase from 'firebase'
import S3 from 'aws-s3'
import AWS from 'aws-sdk'
import { config } from '@/config/s3-bucket'

// Save User Profile Photo to S3 Bucket on AWS
export const saveUserProfilePhoto = async (file) => {
  try {
    const userFirebaseUid = firebase.auth().currentUser.uid
    const myNewFile = new File([file.raw], userFirebaseUid, {type: 'image/png'});
    config.dirName = 'profile'
    const S3Client = new S3(config);
    const response = S3Client.uploadFile(myNewFile, myNewFile.name)
    return response
  } catch (error) {
    return error
  }
}

// Save User Profile Photo to S3 Bucket on AWS
export const getAllCampaignFilesByUser = async (influencer, campaign) => {
  try {
    AWS.config.update({
      accessKeyId: config.accessKeyId, 
      secretAccessKey: config.secretAccessKey, 
      region: config.region
    })
    const s3 = new AWS.S3()
    const params = { 
      Bucket: config.bucketName,
      Delimiter: '',
      Prefix: 'campaigns-content/' + influencer + '/' + campaign + '/'
    }
    s3.listObjects(params, function (err, data) {
      if (err) throw err
      store.commit('setCampaignFiles', data)
    })
  } catch (error) {
    return error
  }
}

// Upload Campaign Files to S3 Bucket on AWS
export const uploadCampaignFile = async (file, influencer, campaign) => {
  try {
    config.dirName = 'campaigns-content/' + influencer + '/' + campaign
    const S3Client = new S3(config);
    const response = S3Client.uploadFile(file, file.name)
    return response
  } catch (error) {
    return error
  }
}

// Upload Campaign Files to S3 Bucket on AWS
export const deleteCampaignFile = async (dirName, fileName) => {
  try {
    config.dirName = dirName.slice(0, -1)
    const S3Client = new S3(config);
    const response = S3Client.deleteFile(fileName)
    return response
  } catch (error) {
    return error
  }
}